//import * as Sentry from '@sentry/react'
import React from 'react'
//import { ToastContainer } from 'react-toastify'
//import { GlobalContextProvider } from 'contexts/GlobalContext'
//import 'libs/SentryErrorReporting' // Enable error reporting
//import 'react-toastify/scss/main.scss'
//import 'styles/app.scss'
//import '@fontsource/lexend/variable.css'

type Props = {
  children: React.ReactNode
  withNotifications?: boolean
}

export default function Base({ children, withNotifications = true }: Props) {
  return (
    <>
      {children}
    </>
  )
  // return (
  //   <Sentry.ErrorBoundary fallback="An error has occurred">
  //     <GlobalContextProvider>
  //       {children}
  //       {withNotifications && (
  //         <ToastContainer
  //           autoClose={4000}
  //           closeButton={false}
  //           draggable={false}
  //           hideProgressBar
  //           position="top-center"
  //           // TODO: animation breaks hiding
  //           //transition="slide"
  //         />
  //       )}
  //     </GlobalContextProvider>
  //   </Sentry.ErrorBoundary>
  // )
}